import { render, staticRenderFns } from "./GroupChooseItem.vue?vue&type=template&id=4da4c92e&"
import script from "./GroupChooseItem.vue?vue&type=script&lang=js&"
export * from "./GroupChooseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports